module.exports = __webpack_public_path__ + "img/axe.e89cff00.png";